export default {
	SET_STATE_ITEM(state, data) {
		Object.assign(state, data)
	},
	SET_LISTENER(state, data) {
		state.listeners.push(data)
	},
	SET_LEAGUE_DATA(state, data) {
		// Get any existing ones that need deletion
		const old = state.leagues.find((x) => x.key == data.key)

		// If we're updating a league, be sure to delete the old one
		if (old) {
			state.leagues.splice(state.leagues.indexOf(old), 1, data)
		} else {
			state.leagues.push(data)
		}
	},
	SET_PAGE_DATA(state, data) {
		// Get any existing ones that need deletion
		const old = state.pages.findIndex((x) => x.key == data.key)

		// If we're updating a page, be sure to delete the old one
		if (old >= 0) {
			state.pages.splice(old, 1, data)
		} else {
			state.pages.push(data)
		}
	},
}
